do ->

    angular
        .module 'fundersclub.layout', []
